var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-box",class:{ 'select-box--selected': _vm.isSelected },attrs:{"data-spec":_vm.dataSpec},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.image)?_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.image}})]):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }